import { useCallback, useMemo } from "react";
import { useFavorites } from "./use-favorites.hook";

export function useMarkFavorites() {
	const { favoriteIds } = useFavorites();

	// Optimization: Create a Set for O(1) lookups
	const favoritesSet = useMemo(() => {
		return new Set(favoriteIds.map((id) => Number(id)));
	}, [favoriteIds]);

	const isFavorite = useCallback(
		(productId: number | string): boolean => {
			const productIdNum =
				typeof productId === "string" ? Number(productId) : productId;
			if (Number.isNaN(productIdNum)) {
				return false;
			}
			return favoritesSet.has(productIdNum);
		},
		[favoritesSet],
	);

	return {
		isFavorite,
		favoriteIds,
	};
}
